declare namespace $ {

	export class $mol_icon_chat_question extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=question.view.tree.d.ts.map